import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StyleHelperService {
  static validateCssString(styles: string): any | undefined {
    let style = String('{' + styles + '}')
      .replace(/"/gi, "'")
      .replace(/\s+/g, ' ')
      .replace(/^{/, '{\n')
      .replace(/\}/g, '}\n')
      .replace(/\n\s*([^\{]+)\s+?\{/g, '\n"$1":{')
      .replace(/([\{;])\s*([^:"\s]+)\s*:/g, '$1"$2":')
      .replace(/":\s*([^\}\{;]+)\s*(;|(\}))/g, '":"$1",$3')
      .replace(/\}/g, '},')
      .replace(/,\s*\}/g, '}');
    style = style.substring(0, style.length - 2);
    try {
      return JSON.parse(style);
    } catch (e) {
      return void 0;
    }
  }

  static wrapStyle(jsonCss: any): string {
    let result = '';
    for (const key in jsonCss) {
      if (jsonCss.hasOwnProperty(key)) {
        const rules = key.split(',');
        for (let i = 0; i < rules.length; i++) {
          result += rules[i].trim();
          result += '{';
          for (const style in jsonCss[key]) {
            if (jsonCss[key].hasOwnProperty(style)) {
              result += style + ':' + jsonCss[key][style] + ';';
            }
          }
          result += '}';
        }
      }
    }
    return result;
  }

  static addOrRemoveStyle(action: 'load' | 'remove', id: string, styles?: string): void {
    const docHead = document.head;
    if (docHead) {
      if (action === 'load') {
        let element = document.getElementById(id) as HTMLStyleElement | null;
        if (element == null) {
          element = document.createElement('style');
          element.setAttribute('id', id);
          element.type = 'text/css';
          if (styles) {
            element.appendChild(document.createTextNode(styles));
          }
          document.getElementsByTagName('head')[0].appendChild(element);
        } else {
          element.innerText = styles || '';
        }
      } else if (action === 'remove') {
        const styleElement = document.getElementById(id);
        if (styleElement != null) {
          styleElement.remove();
        }
      }
    }
  }
}
